// jQuery
gsap.registerPlugin(ScrollTrigger);

const mediaQuery = window.matchMedia("(max-width: 640px)");
const screenWidth = window.innerWidth;

var floatShow = false;

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const yOffset = -100;
      const y =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  });
});

window.addEventListener("load", (event) => {
  const anchor = window.location.hash;
  if (anchor) {
    const element = document.querySelector(anchor);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop - 100,
        behavior: "smooth",
      });
    }
  }

  ScrollTrigger.refresh();
});

function onFirstInvalidTipAdded(node) {
  $("html, body").animate(
    {
      scrollTop: $(".wpcf7-not-valid-tip").first().offset().top - 200,
    },
    0
  );
}

const targetNode = document.body;

const config = { childList: true, subtree: true };

const callback = function (mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === 1 &&
          node.classList.contains("wpcf7-not-valid-tip")
        ) {
          onFirstInvalidTipAdded(node);
        }
      });
    }
  }
};

const observer = new MutationObserver(callback);

observer.observe(targetNode, config);

var scrollTriggers = [];

if (!mediaQuery.matches) {
  window.addEventListener("resize", () => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/csone/"
    ) {
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    } else {
      ScrollTrigger.refresh();
    }
  });
}

window.addEventListener("pageshow", (event) => {
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/csone/"
  ) {
    if (history.state && history.state.scrollPosition) {
      const { x, y } = history.state.scrollPosition;
      window.scrollTo(x, y);
    }
  }
});

window.addEventListener("beforeunload", () => {
  history.replaceState(
    {
      scrollPosition: { x: window.scrollX, y: window.scrollY },
    },
    document.title
  );
});

jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });

  gsap.utils.toArray(".intro-fadein").forEach((target, index) => {
    gsap.fromTo(
      target,
      { autoAlpha: 0, y: 20 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        delay: index * 0.5,
        scrollTrigger: {
          trigger: $(".intro-imageContainer"),
          start: "top 25%",
        },
      }
    );
  });

  $(".open-search").click(function () {
    $(".header-search").addClass("_opened");
    $(".modalBackgroundGray").addClass("_show-search");
  });

  $(".close-search").click(function () {
    $(".header-search").removeClass("_opened");
    $(".modalBackgroundGray").removeClass("_show-search");
  });

  $(".menuPhone-linkContainer.menu-link_plus").click(function () {
    $(this).toggleClass("opened");
  });

  $(".hamburguer").click(function () {
    $(this).find(".hamburguer-icon").toggleClass("opened");
    $(".menuPhone").toggleClass("opened");
  });

  document.addEventListener("scroll", function () {
    // if (window.scrollY > 700) {
    if (window.scrollY > 150) {
      $(".header").addClass("header_effect");
    } else {
      if ($(".header").hasClass("header-top"))
        $(".header").removeClass("header_effect");
    }

    var mainPositionPlusHeight =
      $("main").offset().top + $("main").outerHeight() - 100;

    if (window.scrollY > 150 && window.scrollY < mainPositionPlusHeight) {
      // $(".floatButton").addClass("show");
      if (!floatShow) {
        gsap.fromTo(
          ".floatButton",
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.3,
            onStart: () => {
              gsap.set($(".floatButton"), { display: "flex" });
            },
          }
        );
        floatShow = !floatShow;
      }
    } else {
      // $(".floatButton").removeClass("show");
      if (floatShow) {
        gsap.fromTo(
          ".floatButton",
          {
            opacity: 1,
          },
          {
            opacity: 0,
            duration: 0.3,
            onComplete: () => gsap.set($(".floatButton"), { display: "none" }),
          }
        );
        floatShow = !floatShow;
      }
    }
  });

  if ($(".mv-title").length) {
    const mvTl = gsap.timeline({ delay: 0.5 });

    mvTl
      .fromTo(
        ".mv-left",
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          stagger: 0.1,
        }
      )
      .fromTo(
        ".mv-title",
        { x: 150, y: 0, opacity: 0 },
        {
          x: 0,
          y: 0,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          stagger: 0.1,
        }
      )
      .fromTo(
        ".mv-text",
        { x: 90, y: 0, opacity: 0 },
        {
          x: 0,
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
        }
      );
  }

  if ($(".front-banner").length && screenWidth > 640) {
    gsap.fromTo(
      ".front-banner",
      {
        opacity: 0,
      },
      {
        opacity: 1,
        scrollTrigger: {
          id: "front-banner-trigger",
          trigger: ".banner-effect",
          start: "top top",
          end: "+=1px",
          scrub: true,
        },
      }
    );
  }

  $(".stack-effect").each(function (index, value) {
    let stackScroll = ScrollTrigger.create({
      trigger: value,
      // start: "top top+=80px",
      start: "bottom bottom",
      end: "+=200%",

      pin: true,
      pinSpacing: false,
      scrub: true,
      invalidateOnRefresh: true,
    });

    scrollTriggers.push(stackScroll);
  });

  if ($(".wpcf7-acceptance").length) {
    $(".wpcf7-acceptance").append(
      '<label class="form-label privacy-click " for="privacy" style="margin-left:8px"><a href="/privacy" target="_blank" class="form-label_underline">プライバシーポリシー</a>に同意します</label>'
    );
    $(".privacy-click").click(function () {
      $("[name='privacy']").prop("checked", function (index, oldProp) {
        return !oldProp;
      });
    });
  }

  if ($(".view_more").length) {
    var processing = false;
    $(".view_more").click(function () {
      if (!processing) {
        processing = true;

        var type = $("#hdtype").val();
        var page = parseInt($("#hdpage").val()) + 1;
        var qty = parseInt($("#hdqty").val());
        var max = parseInt($("#hdmax").val());
        var slug = $("#hdslug").val() != "" ? $("#hdslug").val() : "";

        if (page <= max) {
          var formData = new FormData();

          formData.append("action", "view_more");
          formData.append("type", type);
          formData.append("page", page);
          formData.append("qty", qty);
          formData.append("slug", slug);

          $.ajax({
            url: my_ajax_object.ajax_url,
            type: "POST",
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            success: function (data) {
              $("#gridContainer").append(data);
              $("#hdpage").val(page);

              if (page == max) {
                $(".view_more").remove();
              }
              processing = false;
            },
          });
        }
      }
    });
  }
});

// JavaScript

const boxes = gsap.utils.toArray(".box");

if (boxes.length > 0) {
  const loop = horizontalLoop(boxes, {
    paused: false,
    repeat: -1,
    speed: 0.5,
  });
}
const boxesReverse = gsap.utils.toArray(".box-reverse");

if (boxesReverse.length > 0) {
  const loop = horizontalLoop(boxesReverse, {
    paused: false,
    repeat: -1,
    speed: 0.75,
    reversed: true,
  });
}

function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
      repeat: config.repeat,
      paused: config.paused,
      defaults: { ease: "none" },
      onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
    }),
    length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 100,
    snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i, el) => {
      let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
          gsap.getProperty(el, "xPercent")
      );
      return xPercents[i];
    },
  });
  gsap.set(items, { x: 0 });
  totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 100) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth *
      gsap.getProperty(items[length - 1], "scaleX") +
    (parseFloat(config.paddingRight) || 0);
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 100) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop =
      distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
        duration: distanceToLoop / pixelsPerSecond,
      },
      0
    )
      .fromTo(
        item,
        {
          xPercent: snap(
            ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
          ),
        },
        {
          xPercent: xPercents[i],
          duration:
            (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false,
        },
        distanceToLoop / pixelsPerSecond
      )
      .add("label" + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }
  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 &&
      (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }
  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
}

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 2,
  spaceBetween: 40,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".consultantSwiper", {
  slidesPerView: 4,
  spaceBetween: 40,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});
